var isMobileView = function isMobileView() {
  return window.innerWidth < 576;
};

var hasMouseSupport = function hasMouseSupport() {
  return matchMedia('(pointer:fine)').matches;
};

var hasTouchSupport = function hasTouchSupport() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
};

var isTouchOnlyDevice = function isTouchOnlyDevice() {
  return hasTouchSupport() && !hasMouseSupport();
}; // This makes it so that on iOS if you click on an input it doesn't autozoom in.


var addMaximumScaleToMetaViewport = function addMaximumScaleToMetaViewport() {
  var metaEl = document.querySelector('meta[name=viewport]');

  if (metaEl !== null) {
    var content = metaEl.getAttribute('content');
    var regex = /maximum-scale=[0-9.]+/g;

    if (regex.test(content)) {
      content = content.replace(regex, 'maximum-scale=1');
    } else {
      content += ',maximum-scale=1';
    }

    metaEl.setAttribute('content', content);
  } else {
    metaEl = document.createElement('meta');
    metaEl.setAttribute('name', 'viewport');
    metaEl.setAttribute('content', 'width=device-width,initial-scale=1,maximum-scale=1');
    document.getElementsByTagName('head')[0].appendChild(metaEl);
  }
};

export { addMaximumScaleToMetaViewport, hasMouseSupport, hasTouchSupport, isMobileView, isTouchOnlyDevice };